import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

const DeleteConfirmationModal = ({
  isOpen,
  onCloseClick,
  onDeleteClick,
  isCommon = true,
  isLoading = false
}) => {
  return (
    <Modal isOpen={isOpen} size="md" centered>
      <ModalBody>
        <div className="d-flex flex-column justify-content-between align-items-center pt-4">
          <Icon.Trash2 size={60} className="text-danger" />
          <div className="fs-4 pt-2">Are you sure?</div>
          {isCommon ? (
            <div className="fs-6 pt-2">
              Do you really want to delete this item? This process cannot be undone.
            </div>
          ) : (
            <React.Fragment>
              <div className="fs-6 pt-2 text-center">
                Are you sure you want to delete this item? This action is permanent and cannot be
                undone.
              </div>
              <div className="fs-6 pt-2 text-center text-danger">
                All associated data will be permanently lost.
              </div>
            </React.Fragment>
          )}
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        {/* Neutral, not accent — the same call as LogoutConfirmationModal. This is the only
            other ghost Cancel that sits beside a bg-danger action; on the Crimson preset an
            accent Cancel would read as a second red button next to Delete. Every other Cancel
            in the app pairs with a bg-primary Submit, where filled-accent + ghost-accent is a
            coherent pair, and those are deliberately left alone. */}
        <Button onClick={onCloseClick} className="px-5 bg-transparent text-dark">
          Cancel
        </Button>
        <Button
          onClick={onDeleteClick}
          className="px-5 bg-danger text-white border-danger d-flex justify-content-center align-items-center gap-2"
          disabled={isLoading}>
          Delete
          {isLoading && <Spinner size="sm" color="light" />}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DeleteConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  isCommon: PropTypes.bool,
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  isLoading: PropTypes.bool
};

export default DeleteConfirmationModal;
